import { z } from 'zod';

/** Rôles de `utilisateurs.role` (type PostgreSQL `role_utilisateur`). */
export const ROLES = ['super_admin', 'rh', 'lecteur'] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;

/**
 * Un rôle donne accès à tout ce que donne le rôle plus bas : `super_admin`
 * couvre `rh`, qui couvre `lecteur` (docs/SECURITE_RGPD.md § Accès).
 */
const RANG: Record<Role, number> = { lecteur: 0, rh: 1, super_admin: 2 };

export function auMoins(role: Role, requis: Role): boolean {
  return RANG[role] >= RANG[requis];
}

/**
 * Le rôle `lecteur` consulte les statistiques « sans données de contact » :
 * téléphone, e-mail et adresse ne lui sont jamais servis.
 */
export function peutVoirDonneesDeContact(role: Role): boolean {
  return auMoins(role, 'rh');
}

/**
 * Téléphone des candidats : RH et super admin le voient toujours ; un lecteur
 * seulement si le super admin a coché « Voir les téléphones » sur son compte
 * (migration 015). E-mail et adresse restent réservés aux profils RH.
 */
export function peutVoirTelephones(role: Role, voirTelephones: boolean): boolean {
  return peutVoirDonneesDeContact(role) || voirTelephones;
}

/**
 * Déplacer une candidature d'une annonce à une autre (migration 024) : le
 * super admin l'a toujours, un profil RH seulement si le super admin a coché
 * le droit sur son compte. Un lecteur n'écrit rien, le droit ne lui sert pas.
 */
export function peutDeplacerCandidature(role: Role, deplacerCandidature: boolean): boolean {
  if (role === 'super_admin') return true;
  return role === 'rh' && deplacerCandidature;
}
